import Controller from '@ember/controller';

export default class QuickPaymentController extends Controller {}
